module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-drawer', {
    attrs: {
      "title": _vm.couponId ? '编辑优惠券' : '新增优惠券',
      "visible": _vm.dialogVisible,
      "append-to-body": false,
      "custom-class": "c-drawer",
      "size": "65%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.formLoading),
      expression: "formLoading"
    }],
    ref: "couponFormRef",
    attrs: {
      "model": _vm.couponInfo,
      "inline": true,
      "rules": _vm.couponInfoRules,
      "label-width": "120px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券名称:",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.couponInfo.title),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "title", $$v)
      },
      expression: "couponInfo.title"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券类型:",
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.couponInfo.type),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "type", $$v)
      },
      expression: "couponInfo.type"
    }
  }, _vm._l((_vm.couponTypeOptions), function(item) {
    return _c('el-option', {
      key: item.paraValue,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue,
        "default-first-option": ""
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效期类型:",
      "prop": "validityType"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.couponInfo.validityType),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "validityType", $$v)
      },
      expression: "couponInfo.validityType"
    }
  }, _vm._l((_vm.couponValidityTypeOptions), function(item) {
    return _c('el-option', {
      key: item.paraValue,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              固定时: 优惠券Code与当前有效期保持一致\n              "), _c('br'), _vm._v("\n              领取后N天有效: 优惠券Code在领取后N天后有效\n              "), _c('br'), _vm._v("\n              长期有效: 优惠券Code永久有效\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券面额:",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 2,
      "min": 0,
      "controls-position": "right"
    },
    model: {
      value: (_vm.couponInfo.amount),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "amount", $$v)
      },
      expression: "couponInfo.amount"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              满减券: 订单金额满足最低消费，则为减免金额。\n              "), _c('br'), _vm._v("\n              代金券: 直接为减免金额\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券折扣:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 2,
      "max": 1,
      "min": 0,
      "controls-position": "right"
    },
    model: {
      value: (_vm.couponInfo.discount),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "discount", $$v)
      },
      expression: "couponInfo.discount"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              折扣券: 0.8=8折,计算方式: 订单总额*折扣 100*(1-0.8)\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "券折扣上限:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 2,
      "min": -1,
      "controls-position": "right"
    },
    model: {
      value: (_vm.couponInfo.discountLimit),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "discountLimit", $$v)
      },
      expression: "couponInfo.discountLimit"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              表示最多允许折扣多少,与`优惠券折扣`相关，如果不填或者小于等于零，则默认为无限制\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "最低消费:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 2,
      "min": 0,
      "controls-position": "right"
    },
    model: {
      value: (_vm.couponInfo.minCost),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "minCost", $$v)
      },
      expression: "couponInfo.minCost"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              只有金额满足最低消费才能使用\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效期天数:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "controls-position": "right"
    },
    model: {
      value: (_vm.couponInfo.fixedTerm),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "fixedTerm", $$v)
      },
      expression: "couponInfo.fixedTerm"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              N天失效 = 领取时间+有效期天数\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券总量:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": -1,
      "controls-position": "right"
    },
    model: {
      value: (_vm.couponInfo.total),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "total", $$v)
      },
      expression: "couponInfo.total"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              如果不填或者小于等于零，则默认为无限制\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效期结束时间:",
      "prop": "endTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.couponInfo.endTime),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "endTime", $$v)
      },
      expression: "couponInfo.endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券状态:",
      "prop": "status"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.couponInfo.status),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "status", $$v)
      },
      expression: "couponInfo.status"
    }
  }, _vm._l((_vm.couponStatusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              将配合JOB进行启动与结束\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券规则:"
    }
  }, [_c('div', {
    staticClass: "editor",
    attrs: {
      "id": "editor"
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "editFooter-seat"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "editOpera-seat"
  }), _vm._v(" "), _c('div', {
    staticClass: "drawer-footer"
  }, [_c('div', {
    staticClass: "operation"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handlerSave
    }
  }, [_vm._v("保存")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-6cb8ef4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/store/coupon/components/couponEdit.vue
// module id = 1694
// module chunks = 0